import { createSelector } from 'reselect';

const selectState = (state) => state.get('notification');

export const selectMessage = createSelector(selectState, (state) => state.get('message'));

export const selectOpen = createSelector(selectState, (state) => state.get('open'));

export const selectError = createSelector(selectState, (state) => state.get('error'));
